import { useQuery } from '@apollo/client/react';
import { useMemo } from 'react';
import { DrivingDistance, Query, QueryInsurancesArgs } from '../../../@types/codegen/types';
import useInsuranceInquiry from '../../../Gql/ad/useInsuranceInquiry';
import INSURANCE_CALCULATION from '../Queries/INSURANCE_CALCULATION';
import useSettings from '../State/Settings/useSettings';

/** Insurance quotes: insuranceInquiry on the public API, otherwise the legacy query. */
const useInsuranceCalculation = (
  id: string,
  branchId?: string,
  personalNumber?: string,
  drivingDistance?: DrivingDistance
) => {
  const { publicApi } = useSettings();
  const legacy = useQuery<Query, QueryInsurancesArgs>(INSURANCE_CALCULATION, {
    variables: {
      id,
      branch: branchId as string,
      personalNumber: personalNumber as string,
      drivingDistance: drivingDistance as DrivingDistance,
    },
    skip:
      !!publicApi ||
      personalNumber === undefined ||
      drivingDistance === undefined ||
      branchId === undefined,
  });
  const gql = useInsuranceInquiry(publicApi, id, personalNumber, drivingDistance);

  const gqlData = useMemo(
    () => (gql.insurances ? ({ insurances: gql.insurances } as Query) : undefined),
    [gql.insurances]
  );

  if (publicApi) {
    return { loading: gql.loading, error: gql.error, data: gqlData };
  }
  return { loading: legacy.loading, error: !!legacy.error, data: legacy.data };
};

export default useInsuranceCalculation;
